import { addDays } from "date-fns";
import { BoardStatusEnum } from "enums/BoardStatusEnum";
import { MeetingStatusEnum } from "enums/MeetingStatusEnum";
import { createLogger } from "logging";

import { parseDate, urlDateFormat } from "./dates";

const logger = createLogger("helpers/queries");

export const defaultSkip = 0;
export const defaultTake = 20;

export const getDefaultStartDate = (): Date => {
  return addDays(new Date(), -14);
};

export const getTakeFromUrl = (urlParams: URLSearchParams, defaultValue: number): number => {
  return parseInt(urlParams.get("take") || defaultValue.toString(), 10);
};

export const getSkipFromUrl = (urlParams: URLSearchParams, defaultValue: number): number => {
  return parseInt(urlParams.get("skip") || defaultValue.toString(), 10);
};

export const getStartDateFromUrl = (urlParams: URLSearchParams, defaultValue: Date): Date => {
  const rawValue = urlParams.get("startDate");
  if (!rawValue) return defaultValue;
  try {
    const parsed = parseDate(rawValue, urlDateFormat);
    return parsed || defaultValue;
  } catch {
    return defaultValue;
  }
};

export const getIsTemplateFromUrl = (urlParams: URLSearchParams): boolean => {
  return getBooleanFromUrl(urlParams, "isTemplate");
};

export const getOptionalStringFromUrl = (urlParams: URLSearchParams, key: string): string | undefined => {
  return urlParams.get(key) || undefined;
};

export const getStringFromUrl = (urlParams: URLSearchParams, key: string, defaultValue = ""): string => {
  return urlParams.get(key) || defaultValue;
};

export const getBooleanFromUrl = (urlParams: URLSearchParams, key: string): boolean => {
  return urlParams.get(key) === "1";
};

export const getBoardStatusFromUrl = (urlParams: URLSearchParams): BoardStatusEnum | undefined => {
  const raw = urlParams.get("status");
  const result = raw ? BoardStatusEnum[raw as keyof typeof BoardStatusEnum] : undefined;
  logger.debug(`getBoardStatusFromUrl(): ${raw} -> ${result}`);
  return result;
};

export const getMeetingStatusFromUrl = (urlParams: URLSearchParams): MeetingStatusEnum | undefined => {
  const raw = urlParams.get("status");
  const result = raw ? MeetingStatusEnum[raw as keyof typeof MeetingStatusEnum] : undefined;
  logger.debug(`getMeetingStatusFromUrl(): ${raw} -> ${result}`);
  return result;
};
